<template>
  <div class="top-aside">
    <div class="welcome">

        <img src="@/assets/image/home/welcome.jpg" alt="">

        <span>欢迎您 !</span>
        <span>{{ userInfo.userAccount }}</span>
    </div>
    <div @click="handleUserLogout">
      <el-button type="danger" icon="el-icon-switch-button" round>退出</el-button>
    </div>
  </div>
</template>

<script>
import { mapState  } from 'vuex';
export default {
  computed:{
      ...mapState({ 
        userInfo : state =>state.userInfo
      })
  },
  methods :{
    handleUserLogout(){
      this.$store.dispatch('SET_USER_LOGOUT')
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="less" scoped>
.top-aside{
    height: 60px;
    // width: calc(85% - 5px);
    background: #fff;
    box-shadow: 0 5px 10px rgba(170, 170, 170, 0.5);
    // position: fixed;
    // top: 0;
    display: flex;
    justify-content: space-between;
    z-index: 99;
    align-items: center;
    padding: 0 20px;

    .welcome{
      display: flex;
      align-items: center;
      
      img{
        width: 50px;
        height: 50px;
      }

      span{
        margin-left: 10px;

        &:nth-child(3){
          font-weight: bold;
        }
      }

    }
}
</style>